import { alpha } from '@material-ui/core/styles'

// ----------------------------------------------------------------------

export default function Switch(theme) {
  const isLight = theme.palette.mode === 'light'

  return {
    MuiSwitch: {
      styleOverrides: {
        thumb: {
          boxShadow: theme.customShadows.z1,
        },
        track: {
          opacity: 1,
          backgroundColor: theme.palette.grey[isLight ? 400 : 500],
        },
        switchBase: {
          left: 0,
          right: 'auto',
          '&:not(.Mui-checked)': {
            color: theme.palette.grey[isLight ? 100 : 300],
            ...(isLight && {
              '& .MuiSwitch-thumb': {
                boxShadow: `0 0 0 1px ${alpha(theme.palette.grey[900], 0.2)}, 0 1px 2px ${alpha('#000000', 0.2)}`,
              },
            }),
          },
          '&.Mui-checked.Mui-disabled, &.Mui-disabled': {
            color: theme.palette.grey[isLight ? 400 : 600],
          },
          '&.Mui-disabled+.MuiSwitch-track': {
            opacity: 1,
            backgroundColor: `${theme.palette.action.disabledBackground} !important`,
          },
        },
      },
    },
  }
}
